// extracted by mini-css-extract-plugin
module.exports = {"container":"Body_container__2gHmR","bodyWrapper":"Body_bodyWrapper__1aRzX","leftSectionWrapper":"Body_leftSectionWrapper__Cy_iu"};